(function () {
    'use strict';

    angular.module("imApp").factory("helpdocttChangedService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 837,
                    parameters: parms || {}
                });
            },
            listHelpDocChanged: function (setting) {
                return $ihttp.post({
                    method: 838,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
